import { unsetAll } from "../../../exports/event";
import { loggerScope } from "../parser/utils.js";
import { getTrackingAttributes, getTrackingEventsFromElement } from "../parser/attributes.js";
import { initializeAbortSignal, trackingEventListener } from "../event/listener.js";
import { synteticTracking } from "../syntetic/index.js";
import type { Unset } from "../../event/head.js";

const log = loggerScope.scope("register");

export const tracked = new WeakMap<
  HTMLElement,
  [listener: typeof trackingEventListener, string[], unsetSyntetic: Unset]
>();

/**
 *
 *
 *
 *
 */
export function registerTrackingHandler(
  elementToTrack: HTMLElement,
  attrs: ReturnType<typeof getTrackingAttributes>,
): void {
  /*                                                                         */
  /*                              */
  if (tracked.has(elementToTrack)) return;

  log.debug("Register element", elementToTrack);
  const eventsToTrack = getTrackingEventsFromElement(elementToTrack, attrs);

  const controller = new AbortController();
  const listener = trackingEventListener.bind([elementToTrack, controller]);

  eventsToTrack.forEach((eventName) => {
    elementToTrack.addEventListener(eventName, listener, { passive: true });
  });

  /*                                                  */
  initializeAbortSignal(elementToTrack, listener, controller.signal);

  const unsetSyntetic = unsetAll(
    ...synteticTracking.map(([ev, register]) => {
      if (!eventsToTrack.includes(ev)) return;
      log.debug("Register syntetic event", ev, elementToTrack);
      return register(elementToTrack);
    }),
  );

  log.debug("Element registered for events", eventsToTrack, elementToTrack);
  tracked.set(elementToTrack, [listener, eventsToTrack, unsetSyntetic]);
}

/**
 *
 *
 *
 *
 */
export function unregisterTrackingHandler(elementToTrack: HTMLElement): void {
  const cacheData = tracked.get(elementToTrack);
  if (!cacheData) {
    return;
  }

  /*                                                                          */
  log.debug("Unregister element", elementToTrack);
  cacheData[1].forEach((eventName) => {
    elementToTrack.removeEventListener(eventName, cacheData[0]);
  });

  /*                                               */
  cacheData[2]();

  /*                                   */
  tracked.delete(elementToTrack);
}
